import React from 'react';
import { useSelector } from 'umi';
import { mobilePageConfig } from './mobilePageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { nightingalePageConfig } from './nightingalePageConfig';
import { pcPageConfig } from './pcPageConfig';
import GuideRealTimeUser from '@/pages/dashboard/components/UserGuide/RealTimeUser';
import { CASUAL_PAGE_CONFIG } from './casualPageConfig';

const reqParams = '/realtime/users';
const Register = () => {
  const dataFrame = useSelector((state: any) => state?.dashboard?.currentGame?.data_frame || 'mobile');
  const pageMap: any = {
    mobile: mobilePageConfig,
    pc: pcPageConfig,
    pc_inflexion: nightingalePageConfig,
    casual: CASUAL_PAGE_CONFIG
  };
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]} />
      <GuideRealTimeUser/>
    </>
  );
};

export default Register;